module.exports = __webpack_public_path__ + "img/P150T_weapon_18.5162c585.png";